import React, { Dispatch, SetStateAction, useEffect } from "react";
import { Space, Table, Radio, Modal, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { AxiosResponse } from "axios";
import { UseMutateAsyncFunction } from "react-query";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { format } from "date-fns";

type propsType = {
  setIsRestoreOpen: React.Dispatch<React.SetStateAction<boolean>>;
  tableKey: number;
  onHoldSales: AxiosResponse<any, any> | undefined;
  isOnHoldSalesLoading: boolean;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  getRestoresMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      search: string;
      page: number;
    },
    unknown
  >;
  selectedKey: number | null;
  setSelectedKey: Dispatch<SetStateAction<number | null>>;
  onRadioChange: (record: any) => void;
  isSaleDeleting: boolean;
};
const RestoreOrderLists = ({
  tableKey,
  onHoldSales,
  selectedKey,
  onRadioChange,
  isOnHoldSalesLoading,
  isSaleDeleting,
  setSelectedKey,
  page,
  setPage,
  getRestoresMutation,
  setIsRestoreOpen,
}: propsType) => {
  const [t] = useTranslation("common");

  useEffect(() => {
    getRestoresMutation({
      search: "",
      page: page,
    });
  }, [getRestoresMutation, page]);

  const columns: {}[] = [
    {
      title: `${t("order")}`,
      dataIndex: "invoiceNo",
      key: "invoiceNo",
      className: "table-row main",
      render: (record: any) => {
        return `${record}`;
      },
    },
    {
      title: `${t("main-customer")}`,
      dataIndex: "customer",
      key: "customer",
      width: "20rem",
      className: "table-row main",
      render: (record: any) => record?.name,
    },
    {
      title: `${t("date")}`,
      key: "date",
      dataIndex: "date",
      className: "table-row main",
      render: (date: any) => {
        return format(new Date(date), "MM/dd/yyyy HH:mm");
      },
    },
    {
      title: `${t("total-price")}`,
      dataIndex: "amountText",
      key: "amountText",
      width: "8rem",
      className: "table-row main",
      render: (record: any) => record || "00000",
    },
    {
      title: `${t("delivery")}`,
      dataIndex: "deliveryLocation",
      key: "amountText",
      width: "8rem",
      className: "table-row main",
      render: (record: { id: number, location: string }) => record?.location,
    },
    {
      title: `${t("select")}`,
      key: "action",
      width: "3rem",
      align: "center",
      className: "table-row main",
      render: (record: any) => (
        <div>
          <Radio.Group value={record.id === selectedKey ? record.id : null}>
            <Radio value={record.id} />
          </Radio.Group>
        </div>
      ),
    },
  ];
  const confirm = (record: any) => {
    Modal.confirm({
      title: (
        <>
          <Row style={{ justifyContent: 'space-around' }}>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  color: "#FFBC39",
                  fontSize: "45px",
                  marginTop: "22px",
                }}
              />
            </Col>

            <Col span={19}>
              <Col
                style={{
                  fontSize: "32px",
                  color: "#212121",
                }}
              >
                {" "}
                {t("confirm-restore")}
              </Col>
              <Col
                span={19}
                style={{
                  fontSize: "16px",
                  color: "#212121",
                  wordWrap: "break-word",
                }}
              >
                {t("please-confirm-restoring-invoice")}
              </Col>
            </Col>
          </Row>
        </>
      ),

      centered: true,
      icon: null,
      onOk: () => {
        onRadioChange(record);
        setIsRestoreOpen(false);
        document.body.classList.remove("body-scroll-lock");
      },
      okText: `${t("confirm")}`,
      cancelText: `${t("cancel")}`,
      okButtonProps: {
        style: {
          height: "40px",
          background: "#1677FF",
          color: "#fff",
          width: "100px",
        },
      },
      cancelButtonProps: {
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          height: "40px",
          width: "100px",
        },
      },
    });
  };
  return (
    <>
      <Table
        key={tableKey}
        className="bill"
        pagination={{ pageSize: 5 }}
        columns={columns}
        loading={isOnHoldSalesLoading || isSaleDeleting}
        dataSource={onHoldSales?.data?.data}
        rowKey={(record) => record.id}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        onChange={(selectedPage) => {
          setPage(selectedPage.current || 1);
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              confirm(record);
              setSelectedKey(record.id);
            },
          };
        }}
      />
    </>
  );
};

export default RestoreOrderLists;
